import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import UserItemInfoToken from './UserItemInfoToken';
export default function UserInfoToken(_a) {
    var prefix = _a.prefix;
    var intl = useIntl();
    var options = useMemo(function () {
        var attributeOptions = [
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.userInfo.folioId',
                value: 'FOLIO_ID',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.userInfo.extId',
                value: 'EXTERNAL_SYSTEM_ID',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.userInfo.groupId',
                value: 'PATRON_GROUP_ID',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.userInfo.barcode',
                value: 'BARCODE',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.userInfo.username',
                value: 'USERNAME',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.userInfo.firstname',
                value: 'FIRST_NAME',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.userInfo.middlename',
                value: 'MIDDLE_NAME',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.userInfo.lastname',
                value: 'LAST_NAME',
            },
        ];
        return attributeOptions.map(function (option) { return ({
            label: intl.formatMessage({ id: option.labelId }),
            value: option.value,
        }); });
    }, [intl]);
    return (React.createElement(UserItemInfoToken, { prefix: prefix, defaultValue: "EXTERNAL_SYSTEM_ID", attributeName: "userAttribute", options: options }));
}
